import { Order, OrderEvent, OrderType } from 'store/orders/orders.types'

export const TRIP_ELIGIBLE_ORDER_STATUSES: OrderType[] = ['NEW', 'ACTIVE']

export const isEligibleOrder = (order: Order) =>
  TRIP_ELIGIBLE_ORDER_STATUSES.includes(order.status)

export const isAvailableEvent = (event: OrderEvent) =>
  TRIP_ELIGIBLE_ORDER_STATUSES.includes(event.status)
